// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__5gcDm","approved":"Status_approved__FUrdB","rejected":"Status_rejected__30ZCT","expired":"Status_expired__160aS","label":"Status_label__3dUND"};